import {Button, Card, Col, DatePicker, Form, Input, message, Row, Select, Table, Tabs} from 'antd';
import { useEffect, useRef, useState } from 'react';
import { ColumnProps } from 'antd/lib/table';
import React from 'react';
import moment from 'moment';
import { WorkOrderService } from '@gtpl/shared-services/raw-material-procurement';
import { title } from 'process';
import { TabNameReq, WorkOrderInfoReq, WorkOrderItemsReq, WorkOrderReq } from '@gtpl/shared-models/raw-material-procurement';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, FilePdfOutlined, DownloadOutlined } from '@ant-design/icons';
import { SortOrder } from 'antd/lib/table/interface';


const { TabPane } = Tabs;
const {Option} = Select

const WorkOrderGrid = () => {

    const [openTabInfo,setOpenTabInfo] = useState<any[]>([])
    const [page, setPage] = React.useState(1);
    const [form] = Form.useForm()
    const [selectedRows,setSelectedRows] = useState<any[]>([])
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
    const workOrderService = new WorkOrderService()
    const plantId=Number(localStorage.getItem('unit_id'))
    const [closedTabInfo,setClosedTabInfo] = useState<any[]>([])
    const [tabName,setTabName] = useState<string>('Open')
    const [filterForm] = Form.useForm()

    const [baleNumber,setBaleNumber] = useState<any[]>([])
    const [workOrderNo,setWorkOrderNo] = useState<any[]>([])
    const [createWorkOrderDisable,setCreateWorkOrderDisable] = useState<boolean>(true)
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    useEffect(() => {
        getOpenTabInfo()
        getBaleNumberInfo()
    },[])

    const getOpenTabInfo = () => {
       const req = new WorkOrderInfoReq(null,null,null,null)
      if(filterForm.getFieldValue('baleNumber') != undefined){
        req.baleNumber = filterForm.getFieldValue('baleNumber') 
      }
        workOrderService.getOpenBaleDetails(req).then(res => {
            if(res.status){
                setOpenTabInfo(res.data)
            }else{
                setOpenTabInfo([])
            }
        })
    }

    const getClosedTabInfo=()=>{
const req = new WorkOrderInfoReq(null,null,null,null)
      if(filterForm.getFieldValue('workOrderNo') != undefined){
        req.workOrderNo = filterForm.getFieldValue('workOrderNo') 
      }
      if(filterForm.getFieldValue('baleNumber') != undefined){
        req.baleNumber = filterForm.getFieldValue('baleNumber') 
      }
      workOrderService.getWorkOrderInfo(req).then(res => {
          if(res.status){
              setClosedTabInfo(res.data)
          }else{
              setClosedTabInfo([])
          }
      })
    }
    
        const getBaleNumberInfo = () => {
          const req = new TabNameReq(tabName)
          workOrderService.getBaleNumberDropDownInfo(req).then(res => {
              if(res.status){
                  setBaleNumber(res.data)
              }else{
                  setBaleNumber([])
              }
          })
        }

                const getWONumberInfo = () => {
          workOrderService.getWONumberDropDownInfo().then(res => {
              if(res.status){
                  setWorkOrderNo(res.data)
              }else{
                  setWorkOrderNo([])
              }
          })
        }
    

    const onTabChange = (val) => {
      setTabName(val)
      filterForm.resetFields()
    }

        useEffect(() => {
      if(tabName == 'Open'){
        getOpenTabInfo()
        getBaleNumberInfo()
      }else{
        getClosedTabInfo()
        getWONumberInfo()
        getBaleNumberInfo()
      }
    },[tabName])


    const rowSelection = {
  selectedRowKeys,
  onChange: (keys, rows) => {
    setSelectedRowKeys(keys);
    setSelectedRows(rows);
    if(selectedRows.length > 0){
          setCreateWorkOrderDisable(false)
        }else{
          setCreateWorkOrderDisable(true)
        }
  }
};

const onCreateWorkOrder = (val) => {
  if (!selectedRows || selectedRows.length === 0) {
    message.error('Please select at least one bale');
    return;
  }

  if (!val.date) {
    message.error('Please select date');
    return;
  }
  
  for (const row of selectedRows) {
    const qty = Number(row.workOrderQty !== undefined? row.workOrderQty: row.remainingQty);
    const remaining = Number(row.remainingQty || 0);

    if (!qty || qty <= 0) {
      message.error(`Invalid quantity for Bale ${row.baleNo}`);
      return;
    }

    if (qty > remaining) {
      message.error(`Work order qty cannot exceed remaining qty for Bale ${row.baleNo}`);
      return;
    }
  }

  const payload: WorkOrderReq = new WorkOrderReq(
    0,
    null,
    val.date ? moment(val.date).toDate() : null,
    val.remarks || null,
    plantId,
    'admin',
    selectedRows.map((row) =>
      new WorkOrderItemsReq(
        0,
        row.baleId,
        Number(row.workOrderQty !== undefined? row.workOrderQty: row.remainingQty)
      )
    )
  );

  workOrderService.createWorkOrder(payload).then(res => {
    if (res.status) {
      message.success('Work order created successfully');
      form.resetFields();
      setSelectedRows([]);
      setSelectedRowKeys([]);
      getOpenTabInfo();
    } else {
      message.error(res.internalMessage || 'Failed to create work order');
    }
  });
};
      function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : false,
        onFilterDropdownVisibleChange: visible => {
            if (visible) { setTimeout(() => searchInput.current.select()); }
        },
        render: text =>
            text ? (
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : text
            ) : null
    });

    const columns : ColumnProps<any>[]  = [
    {
        title: 'S No',
        key: 'sno',
        width: '70px',
        align: 'left',
        responsive: ['md'],
        render: (text, object, index) => (page - 1) * 10 + (index + 1)
      },
       ...(tabName == 'Close' ? [
              {
        title:'Work Order Date',
        dataIndex:'workOrderDate',
        sorter: (a, b) => moment(a.workOrderDate).unix() - moment(b.workOrderDate).unix(),
        sortDirections: ['descend', 'ascend'] as SortOrder[],
        render:(text,record) => {
          return(
            moment(record.workOrderDate).format('YYYY-MM-DD')
          )
        }
      },
      {
        title:'Work Order No',
        dataIndex:'workOrderNo',
         sorter: (a, b) => a.workOrderNo?.localeCompare(b.workOrderNo),
           sortDirections: ['descend', 'ascend'] as SortOrder[],
         ...getColumnSearchProps('workOrderNo')
      },

       ] : []),
      {
        title:'Bale Number',
        dataIndex:'baleNo',
        sorter: (a, b) => a.baleNo?.localeCompare(b.baleNo),
           sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('baleNo')
      },
      {
        title:'Bale Date',
        dataIndex:'baleDate',
        sorter: (a, b) => moment(a.baleDate).unix() - moment(b.baleDate).unix(),
        sortDirections: ['descend', 'ascend'] as SortOrder[],
        render:(text,record) => {
          return(
            moment(record.baleDate).format('DD-MM-YYYY')
          )
        }
      },
      {
        title:'Variant',
        dataIndex:'variant',
        sorter: (a, b) => a.variant?.localeCompare(b.variant),
           sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('variant')
      },
      {
        title:'Quality',
        dataIndex:'quality',
        sorter: (a, b) => a.quality?.localeCompare(b.quality),
           sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('quality')
      },
      {
        title:'Bale Quantity',
        dataIndex:'baleQty',
        render:(text,record) => {
          return(
            Number(record.baleQty)
          )
        }
      },
      ...(tabName == 'Open' ? [
      
      {
        title:'Remaining Quantity',
        dataIndex:'remainingQty',
        render:(text,record) => {
            return(
                <>{Number(record.remainingQty)}</>
            )
        }
      },
       ] : []),
      
      {
        title:'Work Order Quantity',
        dataIndex:'workOrderQty',
        render:(text,record,index)=> {
            return(
                tabName == 'Open' ? <Input
  value={record.workOrderQty ?? Number(record.remainingQty)}
  onChange={(e) => onWorkOrderQtyChange(e.target.value, record)}
/>: Number(record.workOrderQty)
            )
        }
      }
    ]


//     const onWorkOrderQtyChange = (val, record) => {
//   const updated = openTabInfo.map(item => {
//     if (item.baleId === record.baleId) {
//       return { ...item, workOrderQty: Number(val) };
//     }
//     return item;
//   });

//   setOpenTabInfo(updated);
// };

const onWorkOrderQtyChange = (val, record) => {

  const updated = openTabInfo.map(item => {
    if (item.baleId === record.baleId) {
      return {
        ...item,
        workOrderQty: Number(val)
      };
    }
    return item;
  });

  setOpenTabInfo(updated);

  // update selected rows also
  const updatedSelectedRows = selectedRows.map(item => {
    if (item.baleId === record.baleId) {
      return {
        ...item,
        workOrderQty: Number(val)
      };
    }
    return item;
  });

  setSelectedRows(updatedSelectedRows);
};

    const onSearch = () => {
      if(tabName == 'Open'){
        getOpenTabInfo()
      }else{
        getClosedTabInfo()
      }
    }

        const onReset = () => {
      filterForm.resetFields()
      if(tabName == 'Open'){
        getOpenTabInfo()
      }else{
        getClosedTabInfo()
      }
    }
      return(
        <Card  title={<span style={{ color: 'white' }}>Work Order Generation</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
           <Form form={filterForm} layout='vertical'>
            <Row gutter={24}>
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                    <Form.Item label='Bale No' name='baleNumber'>
                      <Select allowClear showSearch optionFilterProp='children' placeholder='Select Bale Number'>
                        {
                          baleNumber.map(e => {
                            return(
                              <Option key={e.baleNumber} value={e.baleNumber}>{e.baleNumber}</Option>
                            )
                          })
                        }
                      </Select>
                    </Form.Item>
                  </Col>
              {
                tabName == 'Open' ? (<></>) : (<>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                    <Form.Item label='Work Order No' name='workOrderNo'>
                      <Select allowClear showSearch optionFilterProp='children' placeholder='Select Work Order No'>
                        {
                          workOrderNo.map(e => {
                            return(
                              <Option key={e.workOrderNo} value={e.workOrderNo}>{e.workOrderNo}</Option>
                            )
                          })
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                </>)
              }
             
              <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 2 }} lg={{ span: 2 }} xl={{ span: 2 }}>
                <Form.Item>
                  <Button type='primary' onClick={onSearch}>Search</Button>
                </Form.Item>
              </Col>
              <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 2 }} lg={{ span: 2 }} xl={{ span: 2 }}>
                <Form.Item>
                  <Button danger onClick={onReset}>Reset</Button>
                </Form.Item>
              </Col>
            </Row>

          </Form>
            <Tabs onChange={onTabChange}>
                <TabPane key='Open' tab='OPEN'>
                  <Form form={form} initialValues={{date:moment()}} onFinish={onCreateWorkOrder}>
                    <Row gutter={24}>
                      <Col  xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                        <Form.Item label={'Date'} name='date' rules={[{required:true,message:'Date is required'}]}>
                          <DatePicker style={{width:'100%'}}/>
                        </Form.Item>
                      </Col>
                      <Col  xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                        <Form.Item label={'Remarks'} name='remarks' >
                          <Input placeholder='Enter Remarks'/>
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                          <Form.Item>
                            <Button type='primary' htmlType='submit' >Create Work Order</Button>
                          </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                    <Table columns={columns} dataSource={openTabInfo} rowKey={record => record.baleId}
                    rowSelection={{
                      ...rowSelection
                    }}/>
                </TabPane>
                <TabPane key='Close' tab='CLOSED'>
                    <Table columns={columns} dataSource={closedTabInfo}/>
                </TabPane>
            </Tabs>
        </Card>
    )
}

export default WorkOrderGrid